import React, { useState } from "react";

import background from '@cover/weiterdenken/background-1.jpg';
import backgroundSm from '@cover/weiterdenken/background-1-sm.jpg';
import WeiterDenken from "../components/cover/animations/weiterdenken";
import Button from "./../components/button";

export const meta = {
	category: "continue",
	slug: "denken",
	id: "WeiterDenken",
	name: "weiterdenken",
	title: "Die Ziege, der Wolf und der Kohlkopf",
	excerpt: {
		before: "Wie bringt ein Fährmann eine Ziege, einen Wolf und einen Kohlkopf über den Fluss..."
	},
	animation: WeiterDenken,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		alt: "Aus dem Kopf einer Person steigen Zahnräder, die sich mit einer Excel-Tabelle vernetzen."
	}
}

const WeiterdenkenArticle = () => {
	const [isVisible, setIsVisible] = useState(false);

	return (
		<div>
			<p className="articleParagraph">
				Wie bringt ein Fährmann eine Ziege, einen Wolf und einen Kohlkopf über den Fluss, wenn er aber nur eins von den drei auf die Fähre laden darf? Dabei muss er darauf achten, dass die Ziege nicht den Kohlkopf und der Wolf nicht die Ziege frisst!
			</p>
			<p className="articleStatement">
				Wen fährt er also der Reihe nach hinüber?
			</p>

			<div className="articleSolutionWrapper">
				<Button
					to={`#`}
					text={!isVisible ? `Lösung anzeigen` : 'Lösung ausblenden'}
					color={`white`}
					backgroundcolor={`black`}
					addClass={`articleSolutionButton`}
					handleClick={(event) => {
						event.preventDefault();
						setIsVisible(!isVisible);
						document.querySelector('.articleSolution').classList.toggle('is-visible');
					}}
				/>
				<p className="articleSolution articleParagraph">
					Zuerst fährt der Fährmann mit der Ziege ans andere Ufer und allein wieder zurück. Dann fährt er mit dem Wolf ans andere Ufer und mit der Ziege zurück. Danach bringt er den Kohlkopf ans andere Ufer und fährt allein zurück. Zum Schluss bringt er die Ziege ans andere Ufer.
				</p>
			</div>
		</div>
	)
};

export default WeiterdenkenArticle;